import { createBrowserRouter } from 'react-router-dom';
import { rootRoutes } from './rootRoutes';
import { QueryClientProvider } from '@tanstack/react-query';
import { queryClient } from './queryClient';
import { Outlet } from 'react-router-dom';
import { NotificationProvider } from '~/shared/notifications/NotificationsContext';
import { LoadingScreen } from './shared/LoadingScreen';
import { RouteErrorBoundary } from './shared/RouteErrorBoundary';

export const router = createBrowserRouter(
	[
		{
			Component: AppContainer,
			ErrorBoundary: RouteErrorBoundary,
			HydrateFallback: AppLoadingScreen,
			children: [...rootRoutes]
		}
	],
	{
		future: {
			v7_relativeSplatPath: true,
			v7_fetcherPersist: true,
			v7_normalizeFormMethod: true,
			v7_partialHydration: true,
			v7_skipActionErrorRevalidation: true
		}
	}
);

// Shown during the initial loader run (e.g. while secureRouteLoader resolves the
// logged-in user) so the app renders a single spinner instead of a blank screen.
function AppLoadingScreen() {
	return <LoadingScreen message="Loading Duro..." />;
}

function AppContainer() {
	return (
		<QueryClientProvider client={queryClient}>
			<NotificationProvider>
				<Outlet />
			</NotificationProvider>
		</QueryClientProvider>
	);
}
